import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import { defineComponent } from '../../knockout/defineComponent';
import '../../knockout/bindings/modal';
// import kendo from '../../libs/kendo/kendo.core';
import { event as analyticsEvent } from '../../analytics/analytics';

import { ImageRenderer } from '../imageRenderer';
import { CompositeDisposable } from '../../disposable';

interface ISaveImageAction {
  $elementToScreenshot: JQuery;
  fileName: string;
  socialServiceHostName: string;
}

export class SocialManagerArgs {
  saveImage = ko.observable<ISaveImageAction>();

  constructor(public imageRenderer: ImageRenderer) {}
}

class SocialManagerViewModel {
  tweetModalVisible = ko.observable<boolean>(false);

  private _disposable = new CompositeDisposable();

  constructor(private params: SocialManagerArgs) {
    const imageRenderer = params.imageRenderer;

    this._disposable.add(
      params.saveImage.subscribe((action) => {
        if (!action) return;

        imageRenderer.captureImage(action.$elementToScreenshot, (imageData) => {
          // kendo.saveAs({
          //     dataURI: imageData,
          //     fileName: action.fileName,
          //     proxyURL: url.combine(action.socialServiceHostName, urls.social.imageSaveAsPath),
          //     forceProxy: true
          // });

          analyticsEvent('Saved image to disk');

          return $.Deferred().resolve().promise();
        });
      })
    );
  }

  dispose(): void {
    this._disposable.dispose();
  }
}

import html from './socialManager.html';
defineComponent(() => SocialManagerViewModel, 'socialManager', html);
require('./socialManager.less');
